import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './778947f91be5e50ebdfb691e3e7b2ba38c07c4298e845a0da9fb11af3f9a072c.cfe-internal.js';

var _excluded = ["children", "title", "className"];
var FlyoutHeader = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    title = _ref.title,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: ref,
    className: classNames(className, styles.flyoutHeader),
    role: "group",
    "aria-label": title
  }), /*#__PURE__*/React__default.createElement("div", {
    "aria-hidden": "true",
    className: styles.headerContent
  }, title), children);
});

export { FlyoutHeader };
